import { getMenuGroupRoutes } from './groups';
import { getScreenRoutes } from './screens';

export const getMenuRoutes = () => {
    const groupRoutes = getMenuGroupRoutes();
    const screenRoutes = getScreenRoutes();

    return [
        {
            parent: groupRoutes.settings,
            children:
                [
                    screenRoutes.modulesAndMenus,
                    screenRoutes.generalSettings,
                    screenRoutes.accessSettings,
                    screenRoutes.locationSettingsBox,
                    screenRoutes.entryExitTypesScreenSelector,
                    screenRoutes.thirdPartySettings,
                    screenRoutes.issueTypesSettingsScreenSelector,
                    screenRoutes.trainingData,
                    screenRoutes.allergiesExamsDiseasesScreenSelector,
                    screenRoutes.organizationalDefinitionsScreenSelector,
                    screenRoutes.affiliationInstitutionDefinition,
                    screenRoutes.digitalFolderSettings,
                    screenRoutes.requestsSettings,
                    screenRoutes.alertsSettingsScreenSelector,
                ]
        },
        {
            parent: groupRoutes.extensibility,
            children:
                [
                    screenRoutes.extensibilityScreenSelector,
                    screenRoutes.userTables,
                    screenRoutes.systemTables,
                ]
        },
        {
            parent: groupRoutes.publications,
            children:
                [
                    screenRoutes.publicationSettings,
                    screenRoutes.documentsScreenSelector,
                    screenRoutes.consentsScreenSelector,
                    screenRoutes.socialBlacklist,
                ]
        },
        {
            parent: groupRoutes.positions,
            children:
                [
                    screenRoutes.orgChart,
                    screenRoutes.positionEditor,
                    screenRoutes.organizationStructure,
                ]
        },
        {
            parent: groupRoutes.talentAcquisition,
            children:
                [
                    screenRoutes.talentAcquisitionSettings,
                    screenRoutes.onboardingScreenSelector,
                ],
        },
        {
            parent: groupRoutes.personal,
            children:
                [
                    screenRoutes.myPeople,
                    screenRoutes.employeeMaster,
                    screenRoutes.issueManagementScreenSelector,
                    screenRoutes.myAnnotations,
                    screenRoutes.myAnnexes,
                    screenRoutes.myBenefits,
                    screenRoutes.certificate,
                    screenRoutes.digitalCertificates,
                    screenRoutes.myCertificates,
                    screenRoutes.vacations,
                    screenRoutes.myVacations,
                    screenRoutes.loans,
                    screenRoutes.annotationsAnalysis,
                    screenRoutes.digitalFolderAnalysis,
                    screenRoutes.myApprovedConsents,
                ],
        },
        {
            parent: groupRoutes.requestsMenu,
            children:
                [
                    screenRoutes.requests,
                    screenRoutes.myRequests,
                    screenRoutes.myRequestsManager,
                    screenRoutes.myPending,
                    screenRoutes.myPendingEmployer,
                    screenRoutes.delegations,
                    screenRoutes.requestDocuments,
                    screenRoutes.requestedDocuments,
                ],
        },
        {
            parent: groupRoutes.digitalSignature,
            children:
                [
                    screenRoutes.signers,
                    screenRoutes.signedDocuments,
                    screenRoutes.externalDocuments,
                ],
        },
        {
            parent: groupRoutes.timeManagement,
            children:
                [
                    screenRoutes.timeDefinition,
                    screenRoutes.myPeopleSchedule,
                    screenRoutes.mySchedule,
                    screenRoutes.assistance,
                    screenRoutes.myAssistance,
                    screenRoutes.attendanceReport,
                    screenRoutes.extraHoursAuthorization,
                    screenRoutes.assistanceAnalysis,
                ],
        },
        {
            parent: groupRoutes.remunerations,
            children:
                [
                    screenRoutes.conceptsFormulasFunctionsScreenSelector,
                    screenRoutes.ratingsAndGeneralValues,
                    screenRoutes.assetsAndDiscountsScreenSelector,
                    screenRoutes.accountingImputations,
                    screenRoutes.historicAccumulators,
                    screenRoutes.receipts,
                    screenRoutes.digitalReceipts,
                    screenRoutes.myReceipts,
                    screenRoutes.myHistoricalReceipts,
                ],
        },
        {
            parent: groupRoutes.calculationManagement,
            children:
                [
                    screenRoutes.currentProcesses,
                    screenRoutes.processScheduling,
                    screenRoutes.specialProcessExecution,
                    screenRoutes.historicalProcesses,
                    screenRoutes.rebuildAccumulators,
                ],
        },
        {
            parent: groupRoutes.performanceManagement,
            children:
                [
                    screenRoutes.performanceDefinition,
                    screenRoutes.goalsAndObjectives,
                    screenRoutes.evaluationProcessDefinition,
                    screenRoutes.performanceEvaluations,
                    screenRoutes.performanceSummaryAndResults,
                    screenRoutes.performanceInterviewAndFeedback,
                    screenRoutes.performanceEvaluationsCalibration,
                    screenRoutes.talentClassification,
                    screenRoutes.performanceAnalytics,
                ],
        },
        {
            parent: groupRoutes.organizationalDevelopment,
            children:
                [
                    screenRoutes.trainingAndDevelopment,
                ],
        },
        {
            parent: groupRoutes.engagement,
            children:
                [
                    screenRoutes.benefitsDefinitions,
                    screenRoutes.pollScreenSelector,
                    screenRoutes.recognitionScreenSelector,
                ],
        },
        {
            parent: groupRoutes.management,
            children:
                [
                    screenRoutes.transactionLog,
                    screenRoutes.managementDefinition,
                    screenRoutes.query,
                    screenRoutes.myQueries,
                    screenRoutes.kpiIndicators,
                    screenRoutes.geoanalysis,
                ],
        },
    ]
};